/*
 * Sleepee — „Buy now · {cena}” na karcie produktu (makieta 30.09, snippets/sleepee-buy-now.liquid).
 *
 * 1. Umieszczenie: przycisk trafia do .product__submit__buttons formularza Broadcast (dostaje klasę sl-has-buy),
 *    CSS (sleepee-v2.css) układa: ilość → Buy now (pełna szerokość) → „Add to basket” | PayPal obok siebie.
 *    Nie zmieniamy plików Broadcast. Gdy Broadcast podmieni <main> (zmiana produktu), MutationObserver
 *    umieszcza nowy przycisk ponownie.
 * 2. Stan: cena i dostępność z wybranego wariantu (JSON [data-selected-variant] w variant-selects, zdarzenie
 *    variant-change z pub/sub Broadcast); przycisk jest zablokowany, gdy Broadcast blokuje „Dodaj do koszyka”.
 * 3. Kliknięcie: FormData formularza produktu (wariant, ilość z pola powiązanego atrybutem form=, właściwości)
 *    → POST /cart/add.js → przejście na /checkout. Błąd (np. brak stanu) pokazujemy pod przyciskiem.
 */
(function () {
  'use strict';
  if (window.__sleepeeBuyNow) return;
  window.__sleepeeBuyNow = true;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function money(cents) {
    try {
      if (window.theme && typeof window.theme.formatMoney === 'function') {
        return window.theme.formatMoney(cents, window.theme.moneyFormat);
      }
    } catch (e) {}
    return null;
  }

  function scopeOf(el) {
    return el.closest('product-info') || el.closest('.shopify-section') || document;
  }

  function formOf(el) {
    return scopeOf(el).querySelector('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');
  }

  function selectedVariant(scope) {
    var node = scope.querySelector('variant-selects [data-selected-variant]');
    if (!node) return undefined;
    try { return JSON.parse(node.textContent); } catch (e) { return undefined; }
  }

  function sync(buy, variant) {
    var scope = scopeOf(buy);
    var btn = buy.querySelector('[data-sl-buy-btn]');
    var priceEl = buy.querySelector('[data-sl-buy-price]');
    var atc = scope.querySelector('[data-add-to-cart]');
    var v = variant === undefined ? selectedVariant(scope) : variant;

    if (v === null) {
      buy.hidden = true;
    } else if (v && typeof v === 'object') {
      buy.hidden = v.available === false;
      if (priceEl && typeof v.price === 'number') {
        var m = money(v.price);
        if (m) priceEl.innerHTML = m;
      }
    }
    if (btn && !btn.classList.contains('is-loading')) {
      btn.disabled = !!(atc && atc.disabled);
    }
    var wrap = buy.parentNode;
    if (wrap && wrap.classList) wrap.classList.toggle('sl-buy-off', buy.hidden);
  }

  function place(buy) {
    if (buy.classList.contains('sl-placed')) return;
    var scope = scopeOf(buy);
    var wrap = scope.querySelector('.product__submit__buttons');
    if (!wrap) return;
    if (buy.parentNode !== wrap) wrap.appendChild(buy);
    wrap.classList.add('sl-has-buy');
    buy.classList.add('sl-placed');
    sync(buy);

    // Broadcast blokuje „Dodaj do koszyka” na czas pobierania wariantu i dla wyprzedanych — kopiujemy ten stan.
    var atc = scope.querySelector('[data-add-to-cart]');
    if (atc && window.MutationObserver) {
      new MutationObserver(function () { sync(buy); }).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
    }
    var idInput = scope.querySelector('form[action*="/cart/add"] [name="id"]');
    if (idInput) idInput.addEventListener('change', function () { sync(buy); });
  }

  function init() {
    document.querySelectorAll('[data-sl-buy]').forEach(place);
  }

  // Zmiana wariantu (pub/sub Broadcast): dane wariantu przychodzą w zdarzeniu.
  if (typeof window.subscribe === 'function' && window.theme && window.theme.PUB_SUB_EVENTS) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function (e) {
      var data = (e && e.data) || {};
      document.querySelectorAll('[data-sl-buy]').forEach(function (buy) {
        // tylko formularz tej sekcji (np. nie szybki podgląd innego produktu)
        var scope = scopeOf(buy);
        if (data.sectionId && scope.dataset && scope.dataset.section && scope.dataset.section !== String(data.sectionId)) return;
        sync(buy, data.variant);
      });
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sl-buy-btn]');
    if (!btn) return;
    e.preventDefault();
    var buy = btn.closest('[data-sl-buy]');
    var form = formOf(buy);
    var err = buy.querySelector('[data-sl-buy-err]');
    if (!form) return;
    var fd = new FormData(form);
    if (!fd.get('id')) return;

    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    if (err) { err.hidden = true; err.textContent = ''; }

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, j: j }; });
      })
      .then(function (res) {
        if (!res.ok || (res.j && res.j.status)) {
          throw new Error((res.j && (res.j.description || res.j.message)) || '');
        }
        window.location.href = root() + 'checkout';
      })
      .catch(function (ex) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        if (err) {
          err.textContent = (ex && ex.message) || btn.getAttribute('data-error') || '';
          err.hidden = !err.textContent;
        }
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

  // Broadcast podmienia <main> przy przejściu na inny produkt (viewTransition) — nowy przycisk trzeba umieścić ponownie.
  if (window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        document.querySelectorAll('[data-sl-buy]:not(.sl-placed)').forEach(place);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
